import { trackerDelete, trackerGet, trackerPatch, trackerPost } from '../client';
import type {
  PageResult,
  TrackerNode,
  TrackerNodeCreate,
  TrackerNodeUpdate,
} from '../types';

export function listTrackerNodes(params: { page?: number; page_size?: number } = {}) {
  return trackerGet<PageResult<TrackerNode>>('/tracker-nodes', params);
}

export function createTrackerNode(body: TrackerNodeCreate) {
  return trackerPost<TrackerNode>('/tracker-nodes', body);
}

export function updateTrackerNode(id: number, body: TrackerNodeUpdate) {
  return trackerPatch<TrackerNode>(`/tracker-nodes/${id}`, body);
}

export function deleteTrackerNode(id: number) {
  return trackerDelete(`/tracker-nodes/${id}`);
}
